<template>
  <div
    class="approval-template-select-option"
    :class="{ 'approval-template-select-option-compact': compact }"
  >
    <div class="text-body-1 text-textDarkest font-weight-medium">
      {{ template?.name }}
    </div>

    <div
      v-if="template?.description"
      class="text-body-3 text-textLight approval-template-select-option-description"
    >
      {{ template.description }}
    </div>

    <div class="text-body-3 text-textLight">
      {{ stageSlotSummary }}
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatTemplateStageSlotSummary } from '@/helpers/approvalFlows';

const props = defineProps({
  template: {
    type: Object,
    default: null,
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const stageSlotSummary = computed(() => (
  formatTemplateStageSlotSummary(props.template)
));
</script>

<style scoped lang="less">
.approval-template-select-option {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
}

.approval-template-select-option-description {
  white-space: normal;
  line-height: 150%;
}

.approval-template-select-option-compact {
  .approval-template-select-option-description {
    // Hide the description text and show a maximum of 2 lines
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
